export default __webpack_public_path__ + "static/media/bakanlik-beyaz.c0e504cd.png";